import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';

import { inFavoriteSelector } from '../../store/favorite/selectors';

export const FavoriteStructuredSelector = createStructuredSelector({
  inFavorite: inFavoriteSelector
});

export const FavoritePropTypes = {
  inFavorite: PropTypes.bool.isRequired
};
